import EventEmitter from 'events';

export const EVENT_PARTIAL_CONTENT_CHANGED = 'page-partial-content-changed';

export default new EventEmitter();
